import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import BookHistoire from './BookHistoire';
import {fetchHomeStories} from "../../../../../creators/home.stories";


class Book extends React.Component {
    constructor(props){
        super(props);
        this.props.fetchHomeStories();
    }


    render() {
        return (
            <div className="book">
                <div className="pages-wrapper">
                    <div className="page left">
                        {this.props.storiesInitialized && !this.props.storiesLoading && Array.isArray(this.props.stories) && this.props.stories.slice(0, 3).map(article => (
                            <BookHistoire key={article._id} {...article} />
                        ))}
                    </div>
                    <div className="page right">
                        {this.props.storiesInitialized && !this.props.storiesLoading && Array.isArray(this.props.stories) && this.props.stories.slice(3, 6).map(article => (
                            <BookHistoire key={article._id} {...article} />
                        ))}
                    </div>
                </div>
            </div>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        stories: state.homeStories.data,
        storiesLoading: state.homeStories.loading,
        storiesInitialized: state.homeStories.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchHomeStories
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Book);
